import React from 'react';
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import ReactSVG from 'react-svg';
import * as actions from '~/store/actions';
import * as lib from '~/dependencies';
import { electron } from '~/helpers';
import { ArchiveDownIcon } from '~/assets/svgIcons';
import { DAILY_UPDATE_CHECK_INTERVAL } from '~/config/config';
import { Container, CloseIcon, AcceptUpdateButton } from './styles';

export default function BoxUpdater({
  setHasUpdate,
}: {
  setHasUpdate: (state: boolean) => void;
}) {
  const dispatch = useDispatch();
  const { t, i18n } = lib.useTranslation();

  const { newVersionAvailable: updateAvailable } = useSelector(
    (state: RootStateOrAny) => state.system.newVersionAvailable
  );

  function onAcceptUpdateClickHandler() {
    electron.incomingUpdateAccepted();
  }

  function openExternalUrlClickHandler() {
    if (updateAvailable) {
      const { change_log_url } = updateAvailable;
      electron.openExternalUrl({
        url: change_log_url,
      });
    }
  }

  function onCloseClickHandler() {
    setHasUpdate(false);
    dispatch(actions.changeUpdaterMessage(false));

    const closeInterval = setTimeout(() => {
      setHasUpdate(true);
      dispatch(actions.changeUpdaterMessage(true));
      clearTimeout(closeInterval);
    }, DAILY_UPDATE_CHECK_INTERVAL);
  }

  return (
    <Container>
      <ReactSVG src={ArchiveDownIcon} className="updater-icon-container" />
      <div className="text-container">
        <span>{t('components.boxUpdater.title')}</span>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#" onClick={openExternalUrlClickHandler}>
          {t('components.boxUpdater.subTitle')}
        </a>
      </div>
      <div className="button-container">
        <AcceptUpdateButton
          lang={i18n.language}
          onClick={onAcceptUpdateClickHandler}>
          {t('components.boxUpdater.btnUpdate')}
        </AcceptUpdateButton>
      </div>

      <div className="close-icon-container">
        <CloseIcon onClick={onCloseClickHandler} />
      </div>
    </Container>
  );
}
